const pricingData = [
  {
    id: 1,
    price: "10",
    image: "/pricing.jpg",
    title: "Resume Deep Dive And Behavioral",
    about: [
      "Resume Deep Dive And Behavioral",
      "Company Specific",
      "45-60 Mins",
    ],
  },
  {
    id: 2,
    price: "10",
    image: "/pricing.jpg",
    title: "Problem Solving And Behavioral",
    about: ["Problem Solving And Behavioral", "Company Specific", "60-90 Mins"],
  },
  {
    id: 3,
    price: "15",
    image: "/pricing.jpg",
    title: "System Design And Behavioral",
    about: [
      "System Design [LLD/HLD] And Behavioral",
      "Company Specific",
      "45-60 Mins each",
    ],
  },
  {
    id: 4,
    price: "20",
    image: "/pricing.jpg",
    title: "Technical Mock Interview",
    about: [
      "Technical Mock Interview [coding, design]",
      "Company Specific",
      "45-60 Mins each",
    ],
  },
  {
    id: 5,
    price: "22",
    image: "/pricing.jpg",
    title: "Premium Mock Interview",
    about: [
      "Premium Mock Interview [Technical, HM, HR]",
      "Company Specific",
      "45-60 Mins each",
    ],
  },
  {
    id: 6,
    price: "X",
    image: "/pricing.jpg",
    title: "Front End/ML Mock Interview",
    about: [
      "Front End/ML Mock Interview",
      "Company Specific",
      "Coming Soon!! 🔥",
    ],
  },
];

export default pricingData;
